/**
 * Handles the Google auth return: on landing at any URL with
 * `#session_id=<token>` we synchronously exchange it against our backend for a
 * JWT and drop the user on /account with a fresh session.
 */
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { setSession } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/account", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setSession(data.access_token, { email: data.email, role: data.role });
        // Strip the hash and land on account
        window.history.replaceState({}, "", "/account");
        toast.success("Signed in with Google");
        nav("/account", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/account", { replace: true });
      }
    })();
  }, [nav]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[500px] flex-col items-center justify-center px-6 py-24 lg:px-10">
      <div className="font-label text-xs text-[#FF5A1F]">/ SIGNING YOU IN</div>
      <div className="mt-3 font-display text-3xl font-black tracking-tighter">One sec…</div>
      <div className="mt-2 text-sm text-white/50">Finishing Google authentication.</div>
    </div>
  );
}
